import { useEffect } from 'react';
import { useWatch } from 'react-hook-form';
import { useHostQualityContext } from 'pages/analyticsAndHostQuality/useHostQualityContext';
import { HostQualityFilter } from '../types/HostQuality.types';

const HostQualityFilterFormWatcher = () => {
  const { setHostQualityFilter } = useHostQualityContext();
  const formValues = useWatch();

  useEffect(() => {
    setHostQualityFilter({
      ...(formValues as HostQualityFilter),
    });
  }, [formValues]);

  return null;
};

export default HostQualityFilterFormWatcher;
